export default __webpack_public_path__ + "static/media/poster.2a272159.svg";